import './bottomBar.css';
import bottomBarLogo from '../img/companyLogo.png';

const content = {
	logoSrc: bottomBarLogo,
	logoAlt: 'Love\'s Presents',
	logoTitle: 'Love\'s Presents',
	copyrightCompany: 'Love\'s Presents'
};

const BottomBar = () => (
	<div id="bottom-bar">
		<div className="content-frame">
			<span>
				<img src={bottomBarLogo} alt={content.logoAlt} title={content.logoTitle} className="stat-image"/>
				<span>{content.copyrightCompany} &copy; {new Date().getFullYear()}</span>
			</span>
			<span>
				<b>Powered By Purpose</b><br></br>
				Purpose First Foundation 501(c)(3)
			</span>
		</div>
	</div>
);

export default BottomBar;